import { sponsorImages } from './sponsorImages'
import { sponsorWebsites } from './sponsorWebsites'

export const sponsors = [
    {
        id: 1,
        name: 'StockEdge',
        logo: sponsorImages.stockedge,
        website: sponsorWebsites.stockedge,
    },
    {
        id: 2,
        name: 'StockGro',
        logo: sponsorImages.stockgro,
        website: sponsorWebsites.stockgro,
    },
    {
        id: 3,
        name: 'Notion',
        logo: sponsorImages.notion,
        website: sponsorWebsites.notion,
    },
    {
        id: 4,
        name: 'Finlatics',
        logo: sponsorImages.finlatics,
        website: sponsorWebsites.finlatics,
    },
    {
        id: 5,
        name: 'Bazarville',
        logo: sponsorImages.bazarville,
        website: sponsorWebsites.bazarville,
    },
    {
        id: 6,
        name: 'Unstop',
        logo: sponsorImages.unstop,
        website: sponsorWebsites.unstop,
    },
    {
        id: 7,
        name: 'BlueLearn',
        logo: sponsorImages.bluelearn,
        website: sponsorWebsites.bluelearn,
    },
    {
        id: 8,
        name: 'Blunt',
        logo: sponsorImages.blunt,
        website: '#',
    },
    {
        id: 9,
        name: 'Campus Times',
        logo: sponsorImages.campustimes,
        website: '#',
    },
    {
        id: 10,
        name: 'Give My Certificate',
        logo: sponsorImages.givemycertificate,
        website: sponsorWebsites.giveMyCertificate,
    },
    {
        id: 11,
        name: 'Internshala',
        logo: sponsorImages.internshala,
        website: sponsorWebsites.internshala,
    },
    {
        id: 12,
        name: 'Interview Buddy',
        logo: sponsorImages.interviewbuddy,
        website: sponsorWebsites.interviewBuddy,
    },
    {
        id: 13,
        name: 'Markonow',
        logo: sponsorImages.markonow,
        website: '#',
    },
    {
        id: 14,
        name: 'NoticeBard',
        logo: sponsorImages.noticebard,
        website: sponsorWebsites.noticebard,
    },
    {
        id: 15,
        name: 'Startup Talky',
        logo: sponsorImages.startuptalky,
        website: sponsorWebsites.startupTalky,
    },
    {
        id: 16,
        name: 'Startup News',
        logo: sponsorImages.startupnews,
        website: '#',
    },
    {
        id: 17,
        name: 'Top One Percent',
        logo: sponsorImages.toponepercent,
        website: '#',
    },
    {
        id: 18,
        name: 'Travel Yatri',
        logo: sponsorImages.travelyatri,
        website: '#',
    },
    {
        id: 19,
        name: 'Vold',
        logo: sponsorImages.vold,
        website: '#',
    },
    {
        id: 20,
        name: 'Yashahvi Foundation',
        logo: sponsorImages.yashahvi,
        website: '#',
    }
]